import { render, staticRenderFns } from "./dialogMessage.vue?vue&type=template&id=92c3ab98&"
import script from "./dialogMessage.vue?vue&type=script&lang=js&"
export * from "./dialogMessage.vue?vue&type=script&lang=js&"
import style0 from "./dialogMessage.vue?vue&type=style&index=0&id=92c3ab98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports